import { lockBody, unlockBody } from "@plugins";

const bannerBtn = document.querySelector(".js-banner-btn");
const bannerTextContainer = document.querySelector(".js-banner-text-container");

if (window.mobileMedia && bannerBtn && bannerTextContainer) {
    window.addEventListener("load", () => {
        document.body.appendChild(bannerTextContainer);
        initBannerBottomPopup(bannerBtn, bannerTextContainer);
    });
}

function initBannerBottomPopup(button, textContainer) {
    const bannerBtnClose = textContainer.querySelector(".js-banner-btn-close");
    const bannerOverlay = textContainer.querySelector(".js-banner-overlay");

    const openBannerTextContainer = () => {
        textContainer.classList.add("active");

        lockBody(textContainer, { reserveScrollBarGap: true });
    };

    const closeBannerTextContainer = () => {
        textContainer.classList.remove("active");

        unlockBody();
    };

    button.addEventListener("click", () => {
        openBannerTextContainer();
    });

    if (bannerBtnClose) {
        bannerBtnClose.addEventListener("click", () => {
            closeBannerTextContainer();
        });
    }

    if (bannerOverlay) {
        bannerOverlay.addEventListener("click", () => {
            closeBannerTextContainer();
        });
    }
}
